// @purpose GLUE
// "Keep this result on every device" (templates/consumer/share/_keep.html, founder 2026-10-13): the same card
// on the quiz result and the full result. Its sign-in link comes back to the result with `?keep=1`; once
// the card is on the page signed in (`data-keep-ready`), post it once so the link is emailed without a
// second tap. The flag is read at load and removed from the address bar at once, so a reload or a
// shared URL never sends again. The quiz result arrives later by htmx, hence the htmx:load hook.
const PARAM = "keep";
let pending = false;

function take() {
  const url = new URL(window.location.href);
  if (url.searchParams.get(PARAM) !== "1") return;
  pending = true;
  url.searchParams.delete(PARAM);
  window.history.replaceState(window.history.state, "", url.toString());
}

function fire() {
  if (!pending || !window.htmx) return;
  const card = document.querySelector("[data-keep][data-keep-ready]");
  if (!card || !card.dataset.keepUrl) return;
  pending = false;
  window.htmx.ajax("POST", card.dataset.keepUrl, { source: card, target: card, swap: "outerHTML" });
}

export function initKeep() {
  take();
  fire();
  document.addEventListener("htmx:load", fire);
}
